import { defineFcm } from '../shared/factory';

export const FCM_ENABLE_FOLKSONOMY_TOPICS = defineFcm('enable_folksonomy_topics')
	.asBoolean()
	.withDefault(false)
	.toConfig({
		owner: 'TBD',
		scope: 'TBD',
		context: 'homepage and discover feed',
		description: `If disabled, it will show the petition card header only if the petition topic is in the (hardcoded) allow list.
		If enabled, it will show the petition card header with any old topic.`,
		import: false,
	});
